import {
  EmbeddableComponent,
  ComponentOptions,
} from '@chargify/embeddable-component';

import App from './App';

import { defaultSettings } from './settings';
import type { ComponentSettings } from './types';
import BillingHistoryLoader from './components/BillingHistoryLoader';

class BillingHistory extends EmbeddableComponent {
  constructor({
    i18n,
    componentsTheme,
    sessionManager,
    dataAccess,
  }: ComponentOptions) {
    super({ i18n, componentsTheme, sessionManager, dataAccess });
  }

  render(
    container: string | HTMLElement,
    componentSettings?: ComponentSettings
  ) {
    const settings = componentSettings || defaultSettings;
    super.renderComponent<ComponentSettings>(
      container,
      App,
      settings,
      BillingHistoryLoader
    );
  }
}
export default BillingHistory;
